<template>
  <div>
    <b-modal
      size="xl"
      button-size="sm"
      ref="finder"
      hide-footer
      :id="this.id"
      :title="title"
    >
      <UnidadeFederativaList :prefix="updatedPrefix" @onDblClickUnidadeFederativa="unidadeFederativaSelect" />
    </b-modal>

    <lg-form-input-finder
      :value="computedValue"
      @input="updateValue"
      fieldDescription="descricao"
      :label="label"
      invalidFeedback="Unidade Federativa deve ser informada!"
      description=""
      @handleClean="handleClean"
    >
      <template #prepend>
        <b-button
          @click="show"
          class="btn-input-finder"
          pressed
        >
          <b-icon icon="search" />
        </b-button>
      </template>
    </lg-form-input-finder>
  </div>
</template>

<script>
import LgFormInputFinder from "@/core/components/Form/LgFormInputFinder.vue";
import UnidadeFederativaList from "../../modules/cadastros/unidadefederativa/UnidadeFederativaList.vue";

export default {
  components: { LgFormInputFinder, UnidadeFederativaList },
  props: {
    id: String,
    prefix: Array,
    value: Object,
    label:{
      type: String,
      default: "Unidade Federativa",
    }
  },
  data() {
    return {
      internalValue: this.value || {},
    };
  },
  watch: {
    value(newValue) {
      this.internalValue = newValue;
    },
  },
  computed: {
    computedValue: {
      get() {
        return this.internalValue;
      },
      set(newValue) {
        this.internalValue = newValue;
      },
    },
    updatedPrefix() {
      return [...this.prefix, "Unidade Federativa"];
    },
    title() {
      return this.updatedPrefix.join(" > ");
    },
  },
  methods: {
    show() {
      this.$bvModal.show(this.id);
    },
    updateValue(newValue) {
      this.computedValue = newValue;
      this.$emit('input', newValue);
    },
    handleClean() {
      this.computedValue = {};
      this.$emit('input', {});
    },
    unidadeFederativaSelect(item) {
      this.computedValue = item;
      this.$emit('input', item);
      this.$bvModal.hide(this.id);
    },
  },
};
</script>
